export const GET_ACCEPTED_ORDERS = "GET_ACCEPTED_ORDERS";
export const GET_NEW_ORDERS = "GET_NEW_ORDERS";
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const ACCEPTING_ORDER = "ACCEPTING_ORDER";
export const REJECTING_ORDER = "REJECTING_ORDER";
export const GET_DELIVERING_ORDERS = "GET_DELIVERING_ORDERS";
export const ASSIGN_ORDER = "ASSIGN_ORDER";
export const GET_DELIVERY_PENDING_ORDERS = "GET_DELIVERY_PENDING_ORDERS";
export const ORDER_DELIVERING = "ORDER_DELIVERING";
export const CHANGE_SHOP_STATUS = "CHANGE_SHOP_STATUS";
export const CHANGE_ITEM_STATUS = "CHANGE_ITEM_STATUS";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const NO_MORE_NOTIFICATIONS = "NO_MORE_NOTIFICATIONS";
export const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS";
export const NEW_NOTIFICATION = "NEW_NOTIFICATION";
export const UPLOAD_DP = "UPLOAD_DP";
export const SELLER_IS_BLOCKED = "SELLER_IS_BLOCKED";
export const CLEAR_AUTH_MSG = "CLEAR_AUTH_MSG";
